/**
 *
 * Suspend Wire Service
 *
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectResult, selectError } from './selectors';
import { suspendWireRequest } from './actions';

export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  reducer,
  sagas,
  selectStatus,
  selectResult,
  selectError,
  suspendWireRequest,
};



// WEBPACK FOOTER //
// ./src/services/suspendWire/index.js